/**
 * 权限清单
 * https://doc.huanleguang.com/pages/viewpage.action?pageId=385699656
 */
export const PermissionCodes = {
  materialDownload: "materialDownload", // 素材下载
  templateEdit: "templateEdit", // 模板编辑
  elementEdit: "elementEdit", // 元素材编辑
  setModuleMember: "setModuleMember", // 成员席位设置
  materialLogs: "materialLogs", // 素材下载记录
  materialCertsDownload: "materialCertsDownload", // 素材授权书下载
  materialimportDAM: "materialimportDAM", // 素材导入DAM
  materialCertsView: "materialCertsView", // 查看素材授权记录列表
  materialCertWrite: "materialCertWrite", // 素材授权主体填写

  officialWebNavigation: "officialWebNavigation", // 官网导航栏-订购会员
  changeOrgTypeWithTop: "changeOrgTypeWithTop", // 左上角位置租户切换
  changeOrgTypeWithUser: "changeOrgTypeWithUser", // 用户信息面板租户切换
  createOrgEntry: "createOrgEntry", // 左上角租户面包创建组织入口
  upgrateEnterpriseMenu: "upgrateEnterpriseMenu", // 升级为团队/企业菜单栏
  inviteMemberMenu: "inviteMemberMenu", // 邀请成员
  pluginHuaban: "pluginHuaban", // 花瓣浏览器插件
  downloadHuabanApp: "downloadHuabanApp", // 下载花瓣APP
} as const;
